/**
 * Personstamm API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldMetaData } from './fieldMetaData';
import { PsTeilDatumSearchRequestMeta } from './psTeilDatumSearchRequestMeta';
import { PsStrasseFlurnameSearchRequestMeta } from './psStrasseFlurnameSearchRequestMeta';


export interface PersonStammSearchRequestMeta { 
    plz?: number;
    mPlz?: FieldMetaData;
    ahvNummer?: string;
    mAhvNummer?: FieldMetaData;
    ort?: string;
    mOrt?: FieldMetaData;
    geburtsdatum?: PsTeilDatumSearchRequestMeta;
    mGeburtsdatum?: FieldMetaData;
    name?: string;
    mName?: FieldMetaData;
    zpvNummer?: string;
    mZpvNummer?: FieldMetaData;
    ahvVersichertennummer?: string;
    mAhvVersichertennummer?: FieldMetaData;
    sucheOhneGrundbuchbezug?: boolean;
    mSucheOhneGrundbuchbezug?: FieldMetaData;
    strasseFlurname?: PsStrasseFlurnameSearchRequestMeta;
    mStrasseFlurname?: FieldMetaData;
    uid?: string;
    mUid?: FieldMetaData;
    searchMode?: PersonStammSearchRequestMeta.SearchModeEnum;
    mSearchMode?: FieldMetaData;
    vorname?: string;
    mVorname?: FieldMetaData;
    sucheMitGrundbuchbezug?: boolean;
    mSucheMitGrundbuchbezug?: FieldMetaData;
}
export namespace PersonStammSearchRequestMeta {
    export type SearchModeEnum = 'ZPV_SUCHE';
    export const SearchModeEnum = {
        ZPV_SUCHE: 'ZPV_SUCHE' as SearchModeEnum
    };
}


